import { OnInit, Component, Optional, Inject  } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { EventEmitterService } from '../../../../services/EventEmitterService.component';
import { Subscription } from 'rxjs';
import { IContextService, DomainContext } from '@pershing/pershing-core';
import { NxiContextUtils } from '@pershing/nxi-common';
import { PcfService } from '../../../../services/PcfService.component';
import { NxiRestService } from '../../../../services/NXI-Rest.service';
import { PershingTranslationService } from '@pershing/pershing-core';

interface TestObject {
    name: string;
    value: string;
  }

@Component({
    selector: 'Income-Cash-Summary-Filter',
    templateUrl: './IncomeCashSummaryFilterN.component.html',
    styleUrls: ['./IncomeCashSummaryFilter.component.css']
})
export class IncomeCashSummaryFilter implements OnInit {
    timeArray: TestObject[]= [{name: 'All', value: '0'},
                {name: 'Next Week', value: '1'},
                {name: 'Next Two Weeks', value: '2'},
                {name: 'Next Three Weeks', value: '3'},
                {name: 'Next 1 Month', value: '10'},
                {name: 'Next 2 Months', value: '11'},
                {name: 'Next 3 Months', value: '12'},
                {name: 'Next 6 Months', value: '15'},
                {name: 'Next 9 Months', value: '18'},
                {name: 'Next 1 Year', value: '19'}
            ];
    TypeArray: TestObject[]= [{name: 'Announced', value: '0'},
            {name: 'Announced & Projected', value: '1'},
            {name: 'Projected', value: '2'}
        ];
    da: any;
    Ap: any;
    Ai: any;
    Pi: any;
    Ri: any;
    Cf: any;
    timePeriod = '12';
    checkBoxVar= false;
    CashFlowType= '1';
    subs: Subscription;
    acctRef: any;
    isDisabled: Boolean = false;
    serviceUrl: any;
    ismobile: boolean = false;
    isAda: boolean = false;
    showf: boolean = false;
    params: any;
    error: any;
    constructor(private ee: EventEmitterService, private contextService: IContextService, private pcfservice: PcfService, private nxiRestService: NxiRestService,
                private translationService: PershingTranslationService, @Optional() @Inject('AppSettings') appSettings: any) {
                this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
                if (appSettings.deviceType && appSettings.deviceType === 'mobile') {
                    this.ismobile = true;
                 }
                if (appSettings.themeType && appSettings.themeType === 'ada') {
                    this.isAda = true;
                }
            }
    ngOnInit() {
        this.serviceUrl = this.nxiRestService.serviceUrl;
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.acctRef = contextValue.hashValue;
            this.applyFilter();
        });
    }
    updateCheckBox() {
        if (this.CashFlowType === '1') {
            this.isDisabled = false;
        } else {
            this.checkBoxVar = false;
            this.isDisabled = true;
        }
    }
    applyFilter() {
        console.log('accref url', this.acctRef);
        this.params = new HttpParams()
            .set('timePeriod', this.timePeriod)
            .set('docType', this.CashFlowType)
            .set('mfviewType', String(this.checkBoxVar))
            .set('isGDR', 'true');
        this.pcfservice.Incomecashflowfliter(this.serviceUrl, this.acctRef, this.params).subscribe(
            data => {
                this.da = data;
                this.Ap = this.da.announcedPrincipal;
                this.Ai = this.da.announcedIncome;
                this.Pi = this.da.projectedIncome;
                this.Ri = this.da.totalReinvestedIncome;
                this.Cf = this.da.currentMoneyFunds;
                this.ee.emitda(this.Ap, this.Ai, this.Pi, this.Ri, this.Cf, this.CashFlowType);
            },
            err => {
                console.error(err);
                this.error = err;
            },
            () => console.log('data recieved')
        );
    }
    showFilter() {
        this.showf = ! this.showf;
    }
}
